import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ImpMailState } from '../reducers/mailinfo.reducer';

export const impMailState: any = createFeatureSelector<ImpMailState>('mailInfo');

export const impMail = createSelector(impMailState, (state: any) => {
  return state.impMail;
});
